import React, { Component, createRef, Fragment } from 'react';
import { Button, Input, Checkbox, message, Popconfirm, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import CpSearchBar from '../../components/CpSearchBar';
import CpLogo from '../../components/CpLogo';
import CpProductInfo from '../../components/CpProductInfo';
import CpEmpty from '../../components/CpEmpty';
import CpLoading from '../../components/CpLoading';
import { connect } from 'react-redux';
import { addProduct, reduceProduct, modifyProduct, removeProduct, clearProduct, initShopCart } from '../../store/actions/shopCartActions';
import ErpMapForm from '../../components/erpForm/erpMapForm';
import { amountToString, amountStrToNumber } from '../../util/tool';
import { formateErpProducts } from '../../components/erpForm/erpMapConst';
import send from '../../util/request';
import { accAdd, accSub } from '../../util/math';

import './style.less';

const { localStorage } = window;

class ShopCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectProducts: {}, // 记录选中的商品
      suppliers: {},   // 记录各个供应商的商品和选中商品数
      selectedAll: false, // 全选按钮
      totalPrice: 0,
      totalCount: 0,
      totalNumber: 0,
      emptyStatus: '',
      loading: true,
      currentProduct: {},
      erpMap: {}
    };
    this.columns = [
      { key: 'selectState', name: '全选', align: 'left', width: 168 },
      { key: 'product', name: '商品信息', align: 'left' },
      { key: 'unit_amount', name: '单价', align: 'center', width: 260 },
      { key: 'tax_rate', name: '税率', align: 'center', width: 260 },
      { key: 'tax_inclusive_price', name: '商品价格(含税)', align: 'center', width: 260 },
      { key: 'num', name: '数量', align: 'center', width: 500 },
      { key: 'tax_inclusive_subtotal', name: '小计', align: 'right', width: 180 },
      { key: 'action', name: '操作', align: 'center', width: 200 },
    ];
  }

  componentDidMount() {
    const { initShopCart } = this.props;
    initShopCart();
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  forMateErpMap(list = [], map = {}) {
    const erpMap = {};
    for (const item of list) {
      const { supplierId, saleList, isRelation } = item;
      const mappingProducts = saleList.filter(item => !item.is_mapping);
      const selfIds = mappingProducts.map(item => ({ norms_id: item.norms_id }));
      const isMapping = !!mappingProducts.length;
      if ((isMapping || !isRelation) && !map[supplierId]?.isFinished) {
        erpMap[supplierId] = map[supplierId] ? { ...map[supplierId], mappingProducts, isMapping } : {
          supplierId,
          mappingProducts,
          isMapping,
          mapRef: createRef(),
          isRelation,
          expand: false,//折叠开关
          isFinished: false,//是否完成校验
          erpMapData: {},
          selfIds
        };
      }
    }
    for (let i in erpMap) {
      const { selfIds, isFinished } = erpMap[i];
      const formateIds = selfIds.map(item => ({ ...item, isFinished }));
      erpMap[i].formateIds = formateIds;
    }
    return erpMap;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let { shopList, ids } = nextProps;
    let { suppliers, selectProducts, selectedAll, erpMap = {} } = this.state;

    const newErpMap = this.forMateErpMap(shopList, erpMap);

    if (shopList.length <= 0) {
      suppliers = {};
      selectProducts = {};
      selectedAll = false;
    } else {
      shopList.forEach(obj => {
        const { supplierId, saleList = [] } = obj;
        if (!suppliers[supplierId]) {
          suppliers[supplierId] = {
            checkNum: 0,
            productNum: saleList.length,
            checked: false
          };
        }
        saleList.forEach(p => {
          let o = selectProducts[p.norms_id];
          if (o) {
            o.number = p.num;
            o.supplierId = supplierId;
            o.tax_inclusive_price = p.num * amountStrToNumber(p.tax_inclusive_price);
            o.isOnSale = p.is_on_sale;
            o.cartId = p.cartId;
            o.saleId = p.id;
            o.unit = p.unit;
            o.saleName = p.sale_name;
          }
        });
      });

      selectedAll = Object.keys(selectProducts).length === ids.length;
    }

    this.setState({
      suppliers,
      selectProducts,
      selectedAll,
      emptyStatus: shopList.length ? '' : 'shopCart',
      loading: false,
      erpMap: newErpMap
    }, () => {
      // let doms = document.getElementsByClassName('bottom');
      // if (doms && doms.length) {
      //   let bottomBarTop = document.getElementsByClassName('bottom')[0].getBoundingClientRect().top;
      //   let cHeight = document.documentElement.clientHeight;
      //   this.setState({
      //     fixedBottom: bottomBarTop >= (cHeight - 64) ? true : false
      //   });
      // }
      this.computeTotal();
    });
  }

  submitPlanOrder = () => {
    this.submit(2);
  }

  submitOrder = () => {
    this.submit(1);
  }

  submit = (type) => {
    let keys = Object.keys(this.state.selectProducts);
    if (keys.length <= 0) {
      message.info('请先选择商品');
      return;
    }

    let onSaleCount = 0;
    let saleList = [];
    keys.forEach(key => {
      let obj = this.state.selectProducts[key];
      if (obj.isOnSale) { onSaleCount++; }
      if (saleList[obj.saleId]) {
        saleList[obj.saleId].number++;
      } else {
        saleList[obj.saleId] = {
          name: obj.saleName,
          number: 1
        };
      }
    });
    if (onSaleCount !== keys.length) {
      message.info('商品不存在或下架，请刷新购物车');
      return;
    }
    const _saleList = saleList.filter((item) => item.number > 1);
    if (_saleList.length) {
      message.info('不支持商品多规格下单，请核查：' + (_saleList.map((item) => item.name)).join('、'));
      return;
    }

    localStorage.setItem('orderData', JSON.stringify(this.state.selectProducts));
    const { selectProducts, erpMap } = this.state;
    const formateSelectProducts = Reflect.ownKeys(selectProducts);
    const supplierIdList = Object.values(selectProducts).map(item => item.supplierId);
    const computed_select_supplier = [...new Set(supplierIdList)];
    const arr = [];
    for (let i in erpMap) {
      arr.push(...erpMap[i].formateIds);
    }
    const supplierId_finished = computed_select_supplier.reduce((pre, cur) => [...pre, (erpMap[cur]?.isRelation === undefined ? 1 : erpMap[cur]?.isRelation)], []);
    const result = formateSelectProducts.filter(item => {
      return (arr.filter(subItem => {
        if (String(subItem.norms_id) === String(item)) {
          return !subItem.isFinished;
        } else {
          return '';
        }
      })).length;
    });
    const supplierId_finished_result = supplierId_finished.filter(item => !item );
    if (supplierId_finished_result.length) {
      message.error('选择的供应商包含不完整的erp信息，请完成后重试');
    } else if (result.length) {
      message.error('选择的商品包含不完整的erp信息，请完成后重试');
    } else {
      this.props.history.push('/basic/submit/' + type);
    }
  }

  add = (product) => {
    const { num, stock_cur_num, sale_max_count_day, sale_min_count } = product;
    const currentValue = accAdd(num, 1);
    let max = +(sale_max_count_day) === 0 ? +(stock_cur_num) : (+(stock_cur_num) < +(sale_max_count_day)) ? +(stock_cur_num) : +(sale_max_count_day);
    if (currentValue > +max) {
      message.info('超过最大可购买量，不能再加了');
      this.props.modifyProduct(product, +max);
      return;
    }
    if (currentValue < +(sale_min_count)) {
      message.info('商品数量不能小于最小起订量');
      this.props.modifyProduct(product, +sale_min_count);
      return;
    }
    this.props.addProduct(product);
  }

  reduce = (product) => {
    const { num, sale_min_count, norms_id } = product;
    if (accSub(num, 1) < +(sale_min_count)) {
      message.info('商品数量不能再减少了');
      this.props.modifyProduct(product, +sale_min_count);
      return;
    }
    this.props.reduceProduct(norms_id);
  }

  inputChanged = (e, product) => {
    const value = e.target.value;
    // value = Number(value.replace(/[^\d\.*]/ig, ''));
    let currentProduct = Object.assign({}, product, { num: value });
    this.setState({
      currentProduct
    });
  }

  onBlur = (e, product) => {
    const value = e.target.value;
    const regularValue = value.replace(/[^\d.]/ig, '');
    let lastValue = +parseFloat(regularValue).toFixed(3);

    this.setState({
      currentProduct: {}
    });
    if (isNaN(lastValue)) {
      message.info('请输入有效数字');
      return;
    }
    if (!product) { return; }
    const { stock_cur_num, sale_max_count_day, sale_min_count } = product;
    let max = +(sale_max_count_day) === 0 ? +(stock_cur_num) : (+(stock_cur_num) < +(sale_max_count_day)) ? +(stock_cur_num) : +(sale_max_count_day);
    if (lastValue > max) {
      lastValue = max;
      message.info('超过最大可购买量');
    }
    if (lastValue < +(sale_min_count)) {
      message.info('商品数量不能小于最小起订量');
      // return;
      lastValue = +(sale_min_count);
    }
    this.props.modifyProduct(product, lastValue);
  }

  removeProduct = (product) => {
    this.updateCheckChecked(product);
    this.props.removeProduct(product.norms_id, product.cartId);
    this.props.initShopCart();
  }

  removeProducts = () => {
    if (this.state.selectedAll) {
      this.props.clearProduct();
    } else {
      let { selectProducts } = this.state;
      let { products } = this.props;
      let keys = Object.keys(selectProducts);
      if (!keys.length) { return; }

      let cartIds = (Object.values(selectProducts) || []).map(obj => {
        return obj.cartId;
      });

      keys.forEach(key => {
        this.updateCheckChecked(products[key]);
      });

      this.props.removeProduct(keys, cartIds);
    }
    this.props.initShopCart();
  }

  updateCheckChecked(product) {
    let { supplier_id, norms_id } = product;
    let { selectProducts, suppliers } = this.state;

    let item = suppliers[supplier_id];

    if (selectProducts[norms_id]) {
      delete selectProducts[norms_id];
      item.checkNum -= 1;
      item.productNum -= 1;
      item.checked = item.checkNum === item.productNum;
    } else {
      item.productNum -= 1;
      item.checked = item.checkNum === item.productNum;
    }
    suppliers[supplier_id] = item;

    this.setState({
      selectProducts,
      suppliers,
    }, () => {
      this.computeTotal();
    });
  }

  supplierChecked = (e, item) => {
    let checked = e.target.checked;
    let { supplierId, saleList } = item;
    let { selectProducts, suppliers } = this.state;
    let { ids } = this.props;
    let selectedAll = false;

    if (checked) {
      suppliers[supplierId] = {
        checkNum: saleList.length,
        productNum: saleList.length,
        checked: true
      };
      saleList.forEach(product => {
        selectProducts[product.norms_id] = {
          number: product.num,
          tax_inclusive_price: product.num * amountStrToNumber(product.tax_inclusive_price),
          checked: true,
          isOnSale: product.is_on_sale,
          cartId: product.cartId,
          saleId: product.id,
          supplierId,
          unit: product.unit,
          saleName: product.sale_name,
        };
      });
      selectedAll = Object.keys(selectProducts).length === ids.length;
    } else {
      saleList.forEach(product => {
        delete selectProducts[product.norms_id];
      });
      suppliers[supplierId] = {
        checkNum: 0,
        productNum: saleList.length,
        checked: false
      };
    }
    this.setState({
      selectProducts,
      suppliers,
      selectedAll
    }, () => {
      this.computeTotal();
    });
  }

  productChecked = (e, product) => {
    let checked = e.target.checked;
    let { supplier_id, norms_id } = product;
    let { selectProducts, suppliers } = this.state;
    let { ids } = this.props;
    let selectedAll = false;

    if (checked) {
      selectProducts[norms_id] = {
        number: product.num,
        tax_inclusive_price: product.num * amountStrToNumber(product.tax_inclusive_price),
        checked: true,
        isOnSale: product.is_on_sale,
        cartId: product.cartId,
        saleId: product.id,
        supplierId: supplier_id,
        unit: product.unit,
        saleName: product.sale_name,
      };
      let item = suppliers[supplier_id];
      item.checkNum += 1;
      item.checked = item.checkNum === item.productNum;
      suppliers[supplier_id] = item;
      selectedAll = Object.keys(selectProducts).length === ids.length;
    } else {
      delete selectProducts[norms_id];
      let item = suppliers[supplier_id];
      item.checkNum -= 1;
      item.checked = item.checkNum === item.productNum;
      suppliers[supplier_id] = item;
    }

    this.setState({
      selectProducts,
      suppliers,
      selectedAll
    }, () => {
      this.computeTotal();
    });
  }

  selectedAll = (e) => {
    let checked = e.target.checked;
    let { selectProducts, suppliers } = this.state;
    let { shopList } = this.props;

    if (checked) {
      shopList.forEach(obj => {
        suppliers[obj.supplierId] = {
          checkNum: obj.saleList.length,
          productNum: obj.saleList.length,
          checked: true
        };
        obj.saleList.forEach(product => {
          selectProducts[product.norms_id] = {
            number: product.num,
            tax_inclusive_price: product.num * amountStrToNumber(product.tax_inclusive_price),
            checked: true,
            isOnSale: product.is_on_sale,
            cartId: product.cartId,
            saleId: product.id,
            supplierId: obj.supplierId,
            unit: product.unit,
            saleName: product.sale_name,
          };
        });
      });
    } else {
      Object.values(suppliers).forEach(obj => {
        obj.checkNum = 0;
        obj.checked = false;
      });
      selectProducts = {};
    }

    this.setState({
      selectProducts,
      suppliers,
      selectedAll: checked
    }, () => {
      this.computeTotal();
    });
  }

  computeTotal = () => {
    let totalCount = 0, totalPrice = 0, totalNumber = 0;
    const { selectProducts } = this.state;

    const values = Object.values(selectProducts);
    totalCount = values.length;
    values.forEach(obj => {
      totalPrice = accAdd(totalPrice, (+obj.tax_inclusive_price).toFixed(2));
      totalNumber = accAdd(totalNumber, obj.number);
    });

    this.setState({
      totalCount,
      totalNumber,
      totalPrice: amountToString(totalPrice)
    });
  }

  toProductDetail = (product) => {
    const { spu_id, supplier_id, norms_id } = product;
    if (!spu_id || !supplier_id || !norms_id) {
      message.info('商品缺少spu_id或norms_id或supplier_id');
      return;
    }
    this.props.history.push('/basic/product/detail/' + spu_id + '/' + supplier_id + '/' + norms_id);
  }

  searchTypeChanged = (value) => {
    this.setState({
      searchType: value
    });
  }

  searchValueChanged = (value) => {
    this.setState({
      searchValue: value
    });
  }

  openErpForm = item => {
    const { erpMap = {} } = this.state;
    const { supplierId } = item;
    const currentMap = erpMap[supplierId];
    const { expand, mapRef } = currentMap;
    if (expand) {//即将关闭
      // console.log(mapRef.form.getFieldsValue(), 'mapRef')
      erpMap[supplierId]['erpMapData'] = mapRef?.form?.getFieldsValue() || {};
    }
    erpMap[supplierId]['expand'] = !expand;
    this.setState({ erpMap });
  }

  erpMapSubmit = async values => {
    const { supplierId, ...value } = values;
    const { erpMap = {} } = this.state;
    const { expand, isRelation, mappingProducts = [] } = erpMap[supplierId];
    const { rel_company_name, primary_code, sub_code, ...productsMap } = value || {};
    const postData = {};
    if (!isRelation) {
      postData["relation"] = { rel_company_id: supplierId, rel_company_name, primary_code, sub_code };
    }
    if (mappingProducts.length) {
      postData['mapping'] = mappingProducts.map(item => {
        const { sale_id, base_unit, sku_no } = item;
        return {
          out_prop: productsMap[`out_prop_${sale_id}`],
          out_unit: productsMap[`out_unit_${sale_id}`],
          out_sku_no: productsMap[`out_sku_no_${sale_id}`],
          base_unit,
          sku_no
        };
      });
    }
    const { data: { code, msg } } = await send({ url: '/ipp/order-purchase/relation-mapping', method: 'POST', data: postData });

    if (+code === 0) {
      erpMap[supplierId]['expand'] = !expand;
      erpMap[supplierId]['isFinished'] = true;
      erpMap[supplierId]['isRelation'] = 1;
      erpMap[supplierId]['is_relation'] = 1;
      message.success(msg, .5, this.setState({ erpMap }));
    } else {
      message.error(msg);
    }
  }

  erpMapCancel = async values => {
    const { supplierId } = values;
    const { erpMap = {} } = this.state;
    const currentMap = erpMap[supplierId];
    const { mapRef } = currentMap;
    const erpMapData = formateErpProducts(currentMap);
    for (let item in erpMapData) {
      erpMapData[item] = '';
    }
    mapRef.form.setFieldsValue(erpMapData);
    erpMap[supplierId]['expand'] = false;
    this.setState({ erpMap });
  }

  render() {
    const { shopList } = this.props;
    const { fixedBottom = true, selectProducts, suppliers, selectedAll, totalCount, totalNumber, totalPrice, emptyStatus, loading, currentProduct, searchValue = '', searchType = '1', erpMap = {} } = this.state;

    const header = (
      <div className="shop-cart-top">
        <CpLogo />
        <div style={{ marginLeft: '40px' }}>
          <CpSearchBar
            searchValue={searchValue}
            searchType={searchType}
            searchValueChanged={this.searchValueChanged}
            searchTypeChanged={this.searchTypeChanged} />
        </div>
      </div>
    );

    const empty = (<div className="cart-empty"><CpEmpty status={emptyStatus} history={this.props.history} /></div>);

    return (
      <div className="shop-cart">
        {header}
        {(shopList.length <= 0 && emptyStatus.length) ? empty :
          <div className="shop-cart-content">
            {loading ? <CpLoading className="cp-loading" /> : null}
            <div className="shop-cart-list">
              <table className="cp-table">
                <thead>
                  <tr>
                    {
                      this.columns.map((item, index) => {
                        return (
                          <th key={index} colSpan={item.colSpan || 1} style={{ textAlign: item.align, width: item.width }}>
                            {index === 0 && (<Checkbox style={{ margin: '0px 12px' }} checked={selectedAll} onChange={this.selectedAll}></Checkbox>)}{item.name}
                          </th>
                        );
                      })
                    }
                  </tr>
                </thead>
                <tbody>
                  {
                    shopList.map((item, index) => {
                      return (
                        <Fragment key={index}>
                          <tr>
                            <td colSpan={this.columns.length} className="td-group">
                              <div className='shop-cart-table-provider'>
                                <div>
                                  <Checkbox style={{ margin: '0px 12px' }} checked={suppliers[item.supplierId] ? suppliers[item.supplierId].checked : false} onChange={(e) => { this.supplierChecked(e, item); }}></Checkbox>供应商：{item.supplierName}
                                </div>
                                {
                                  !erpMap[item.supplierId]?.['isFinished'] ? <div>
                                    {/* {erpMap[item.supplierId]?.expand ? <Typography.Link className='shop-cart-table-provider-erp-tip'><InfoCircleOutlined />请添加ERP供应商或商品映射</Typography.Link> : null} */}
                                    {erpMap[item.supplierId] ? <><Typography.Link className='shop-cart-table-provider-erp-tip' onClick={() => this.openErpForm(item)}><InfoCircleOutlined />请添加ERP供应商映射</Typography.Link></> : null}
                                  </div> : null
                                }
                              </div>
                              {
                                // erpMap[item.supplierId]?.expand && erpMap[item.supplierId]?.['isFinished'] ?
                                erpMap[item.supplierId]?.expand ?
                                  <ErpMapForm
                                    currentMap={erpMap[item.supplierId]}
                                    // wrappedComponentRef={el => erpMap[item.supplierId].mapRef = el}
                                    ref={el => erpMap[item.supplierId].mapRef = el}
                                    erpMapSubmit={this.erpMapSubmit}
                                    erpMapCancel={this.erpMapCancel}
                                  />
                                  : null
                              }
                            </td>
                          </tr>
                          {
                            item.saleList.map((p, idx) => {
                              return (
                                <tr key={idx}>
                                  {
                                    this.columns.map((col, index) => {
                                      if (col.key === 'selectState') {
                                        return null;
                                      } else if (col.key === 'product') {
                                        return (
                                          <td key={index} colSpan={2}>
                                            <div className="product-info">
                                              <Checkbox className="product-checked" checked={selectProducts[p.norms_id] ? selectProducts[p.norms_id].checked : false} onChange={(e) => { this.productChecked(e, p); }} ></Checkbox>
                                              <CpProductInfo product={p} toProductDetail={() => { this.toProductDetail(p); }} />
                                            </div>
                                          </td>
                                        );
                                      } else if (col.key === 'num') {
                                        return (
                                          <td key={index} style={{ textAlign: 'center' }}>
                                            <div className="countContainer">
                                              <span className="btn pointer" onClick={() => { this.reduce(p); }}>-</span>
                                              <Input className="input" defaultValue={p.num} value={currentProduct.norms_id === p.norms_id ? currentProduct.num : p.num} onChange={(e) => { this.inputChanged(e, p); }} onBlur={(e) => { this.onBlur(e, p); }} onPressEnter={(e) => { this.onBlur(e, p); }} />
                                              <span className="btn pointer" onClick={() => { this.add(p); }}>+</span>
                                            </div>
                                          </td>
                                        );
                                      } else if (col.key === 'action') {
                                        return (
                                          <td key={index} style={{ textAlign: 'center' }}>
                                            <Popconfirm
                                              title="确定要删除商品吗?"
                                              onConfirm={() => this.removeProduct(p)}
                                              okText="确认"
                                              cancelText="取消"
                                            >
                                              <span className='pointer'>删除</span>
                                            </Popconfirm>
                                          </td>);
                                      } else if (col.key === 'tax_inclusive_subtotal') {
                                        return (<td key={index} style={{ textAlign: 'right', fontWeight: '600' }}>￥{amountToString(p.num * amountStrToNumber(p.tax_inclusive_price))}</td>);
                                      } else if (col.key === 'tax_rate') {
                                        return (<td key={index} style={{ textAlign: col.align, fontWeight: '600', color: col.color }}>{p[col.key] >= 0 ? (+p[col.key] + '%') : '-'}</td>);
                                      } else {
                                        return (<td key={index} style={{ textAlign: col.align, fontWeight: '600' }}>￥{p[col.key]}</td>);
                                      }
                                    })
                                  }
                                </tr>
                              );
                            })
                          }
                        </Fragment>
                      );
                    })
                  }
                </tbody>
              </table>
            </div>
            {
              fixedBottom && (<div className="whitespace"></div>)
            }
            {
              shopList.length <= 0 ? null :
                <div className={fixedBottom ? 'bottom fixed-bottom' : 'bottom'}>
                  <div className="bottom-content">
                    <div className="bottom-left">
                      <div className="bottom-select-all"><Checkbox style={{ margin: '0px 12px' }} checked={selectedAll} onChange={(e) => { this.selectedAll(e); }}></Checkbox>全选</div>
                      <div className="bottom-delete-select">
                        <span className='pointer' onClick={() => { this.removeProducts(); }}>删除所选商品</span>
                      </div>
                    </div>
                    <div className="bottom-right">
                      <div className="bottom-select-count">已选择<span className="bottom-select-count-value">{totalCount}</span>种({totalNumber})件商品</div>
                      <div className="bottom-select-price">总价：<span className="bottom-select-price-value">￥{totalPrice}</span></div>
                      {/* <Button className="bottom-submit-plan" onClick={this.submitPlanOrder}>提交计划单</Button> */}
                      <Button className="bottom-submit-settlement" onClick={this.submitOrder}>去结算</Button>
                    </div>
                  </div>
                </div>
            }
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { sellers, products, ids } = state.shopCart;
  const shopList = Object.values(sellers).map(seller => {
    const { id: supplierId, name: supplierName } = seller;
    let isRelation = false;
    const saleList = (seller.productIds || []).map(item => {
      const currentProducts = products[item];
      isRelation = currentProducts.isRelation;
      return currentProducts;
    }) || [];
    return {
      supplierId,
      supplierName,
      saleList,
      isRelation
    };
  });

  return {
    shopList,
    ids,
    products
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initShopCart: () => {
      dispatch(initShopCart());
    },
    addProduct: (product) => {
      dispatch(addProduct(product, 1, false));
    },
    reduceProduct: (productId) => {
      dispatch(reduceProduct(productId));
    },
    modifyProduct: (product, num) => {
      dispatch(modifyProduct(product, num));
    },
    removeProduct: (productId, cartId) => {
      dispatch(removeProduct(productId, cartId));
    },
    clearProduct: () => {
      dispatch(clearProduct());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShopCart);
